
/**
 * Assets
 */
export default class Assets {

    /**
     * Standard animation time for zooming to floors
     *
     * @type {Number}
     */
    public static FOR_PRELOADER: any = [
        {
            type: window.createjs.Types.BINARY,
            src: "./assets/main.css",
        },
        {
            id: "orbit.js",
            // type: window.createjs.Types.BINARY,
            src: "./assets/main.js",
        },
    ];

}
